import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Card, CardContent } from "../components/ui/card";

import { Footer } from "../components/Footer";
import { CompactHeader } from "../components/CompactHeader";
import * as Constants from "../../constants";
import BackLoader from "../../components/backloader";
export default function HeadsofUnit() {
  const leadershipTeam = [
    {
      name: "Mr E Alli",
      title: "Head, Legal Service Unit",
      image: `${Constants.baseurl}/assets/landing_images/6.jpg`,
    },
    {
      name: "Mrs. A.A Agbaje",
      title: " Head, Work Force Planning & Recruitment Division",
      image: `${Constants.baseurl}/assets/landing_images/agbaje.jpg`,
    },
    {
      name: "Mr. F. Oyenusi",
      title: "Head, Protocol Unit",
      image: `${Constants.baseurl}/assets/landing_images/Oyenusi.jpg`,
    },
    {
      name: "Mrs. O.O Ige",
      title: "Head, Public Affairs Unit",
      image: `${Constants.baseurl}/assets/landing_images/7.jpg`,
    },
    {
      name: "Mrs. F.O Fakolujo",
      title: "Head, Procurement Unit",
      image: `${Constants.baseurl}/assets/landing_images/Fakolujo.jpg`,
    },
    {
      name: "Mr. S.O. Kole",
      title: "Employee Relation",
      image: `${Constants.baseurl}/assets/landing_images/Adeyemi.jpg`,
    },
    {
      name: "Mr. S.M Adeyemi",
      title: "Head, Learning & Development or Project Division ",
      image: `${Constants.baseurl}/assets/landing_images/Adeyemi.jpg`,
    },
    {
      name: "Mr. O. Oyekanmi",
      title: "Head,Budget & Planning Unit",
      image: `${Constants.baseurl}/assets/landing_images/8.jpg`,
    },
    {
      name: "Mrs. B.R. Bakare",
      title: "Head, General Admin Division",
      image: `${Constants.baseurl}/assets/landing_images/Bakare.jpg`,
    },
    // { name: 'Mrs O O Ige', title: 'Head Public Affairs Unit', image: po7 },
    //{ name: 'Mr O I Oyekanmi', title: 'Head Budget & Planning', image: po8 },
    {
      name: "Mr K A Oladehinde",
      title: "Head, Internal Audit Section",
      image: `${Constants.baseurl}/assets/landing_images/9.jpg`,
    },
    {
      name: "Mrs. F. Folarin",
      title: "Human Resource Measure & Accountability",
      image: `${Constants.baseurl}/assets/landing_images/Folarin.jpg`,
    },
    {
      name: "Mrs. Adegboye Rabiat E",
      title: "Head of Library (Acting)",
      image: `${Constants.baseurl}/assets/landing_images/Adegboye.jpg`,
    },
    {
      name: "Mr. W. Sule",
      title: "Head, ICT Unit",
      image: `${Constants.baseurl}/assets/landing_images/sule.jpg`,
    },
  ];

  const [searchParams] = useSearchParams();
  const [textSize, setTextSize] = useState("normal");

  const [leadership, setLeadership] = useState([]);
  const [category, setCategory] = useState("Head of Unit");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    onLoadTeam();
  }, []);
  const onLoadTeam = async () => {
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/cms/team/${category}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setLeadership(data.items);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <CompactHeader />
      {/* Hero Section */}
      <section className="relative py-24 bg-hero-light-image dark:bg-hero-dark">
        <div className="absolute inset-0 bg-black/5 dark:bg-black/30"></div>

        <div className="container mx-auto px-4 sm:px-6 max-w-7xl relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 text-gray-900 dark:text-white">
              <div>Heads Of Unit</div>
              <small>High Court of Lagos State</small>
            </h1>
          </div>
        </div>
      </section>

      {/* Leadership Section */}
      <section
        id="CourtLeadership"
        className="py-20 bg-gray-50 dark:bg-gray-800"
      >
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
          {/* 4 Cards Per Row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {leadership.map((leader, index) => (
              <Card
                key={index}
                className="border-0 shadow-lg hover:shadow-xl transition-shadow group"
              >
                <CardContent className="p-6">
                  <div className="aspect-square bg-gradient-to-br from-blue-100 to-blue-200 dark:from-blue-900 dark:to-blue-800 rounded-xl mb-4 overflow-hidden">
                    <img
                      src={`${Constants.docUrl}cms/team/${leader.coverImage}`}
                      alt={leader.fullName}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>

                  <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
                    {leader.fullName}
                  </h3>

                  <p className="text-blue-600 dark:text-blue-400 font-medium mb-3">
                    {leader.position}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
      <Footer />
      <BackLoader open={loading} />
    </div>
  );
}
